import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV !== "local") {
  Sentry.init({
    dsn: 'https://0c8e1a061f554bb7bf0e284b1b93cab4@sentry.io/1473420',
    environment: process.env.NODE_ENV
  });
}

const rootEl = document.getElementById('app-site');

// Create a reusable render method that we can call more than once
let render = () => {
  // Dynamically import our main App component, and render it
  const MainApp = require('./MainApp').default;
  ReactDOM.render(
    <MainApp/>,
    rootEl
  );
};

if (module.hot) {
  module.hot.accept('./MainApp', () => {
    const MainApp = require('./MainApp').default;
    render(
      <MainApp/>,
      rootEl
    );
  });
}

render();
